import axios from "../utils/axios";
// import CryptoJS from "crypto-js";

const setAuthToken = () => {
  const token = localStorage.getItem("token");

  if (token) {
    // console.log(token);

    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default setAuthToken;
